<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content class="content" [class.loaded]="_loaded">
    <mat-progress-bar class="loading-indicator" mode="indeterminate"></mat-progress-bar>
    <div class="auth-container" id="firebaseui-auth-container"></div>
</div>
